export default "__VITE_ASSET__BKxYUShE__"